import type { ICustomControlRequestReadProps } from '../../pages/customControls/interfaces/customControlRequestReadProps';
import { ButtonContainer } from '../common';
import { BecomeRequesterButton } from './BecomeRequesterButton';
import { CancelProcessButton } from './CancelProcessButton';
import { EditRequestButton } from './EditRequestButton';
import { PrintCarePathButton } from './PrintCarePathButton';
import { TakeRequestButton } from './TakeRequestButton';

export function ContactReadButtons(props: ICustomControlRequestReadProps) {
    return (
        <ButtonContainer
            alignRight
            buttons={[
                <PrintCarePathButton
                    isLastItem={props.isLastItem}
                    request={props.request}
                />,
                <CancelProcessButton
                    cancelProcess={props.removeProcess}
                    request={props.request}
                    serviceCode={props.serviceCode}
                />,
                <EditRequestButton
                    editRequest={props.editRequest}
                    request={props.request}
                />,
                <TakeRequestButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
                <BecomeRequesterButton
                    reloadProcess={props.reloadProcess}
                    request={props.request}
                />,
            ]}
        />
    );
}
